<template>
  <div
    class="is-flex"
    style="width: 100% !important; justify-content: space-between"
  >
    <div id="content-header">
      <div class="notification">
        <div class="notiglow"></div>
        <div class="notiborderglow"></div>
        <div class="notititle">Reporte - Factores de Riesgo Psicosocial</div>
        <div class="nosubtititle">{{ frsm.cliente }}</div>
        <div class="notibody">
          <span>{{ frsm.nombre }} - {{ dateToString(frsm.created) }}</span>
        </div>
      </div>
    </div>
    <img
      style="height: 120px !important;"
      src="@/assets/logo2.png"
      alt="Logo"
    />
  </div>
</template>

<script>
import domtoimage from "dom-to-image-more";

export default {
  props: {
    frsm: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const filter = (node) => {
      // Ignorar hojas de estilo externas y enlaces de fuentes
      return !(
        node instanceof HTMLLinkElement &&
        node.href.includes("fonts.googleapis.com")
      );
    };

    this.$nextTick(() => {
      const element = document.getElementById("content-header");

      domtoimage
        .toPng(element, {
          filter: filter,
        })
        .then(function(dataUrl) {
          const img = new Image();
          img.src = dataUrl;
          element.innerHTML = "";
          element.appendChild(img);
        })
        .catch(function(error) {
          console.error("Error generating image:", error);
        });
    });
  },
  methods: {
    dateToString(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  flex-direction: column;
  isolation: isolate;
  position: relative;
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 1rem;
  overflow: hidden;
  font-size: 16px;
  --gradient: linear-gradient(to bottom, #d27ff9, #a84ff7, #9246df, #9641cc);
  --color: #9641cc;
}

.notification:before {
  position: absolute;
  content: "";
  inset: 0.0625rem;
  border-radius: 1rem;
  background: #fff;
  z-index: 2;
}

.notification:after {
  position: absolute;
  content: "";
  width: 0.25rem;
  inset: 0.65rem auto 0.65rem 0.5rem;
  border-radius: 0.125rem;
  background: var(--gradient);
  transition: transform 300ms ease;
  z-index: 4;
}

.notititle {
  color: var(--color);
  padding: 0.65rem 0.25rem 0 1.25rem;
  font-weight: 700;
  font-size: 1.7rem;
  z-index: 5;
}

.nosubtititle {
  color: var(--color);
  padding: 0 0.25rem 0.4rem 1.25rem;
  font-weight: 700;
  z-index: 5;
}

.notibody {
  color: #99999d;
  padding: 0 1.25rem;
  z-index: 5;
}

.notiglow,
.notiborderglow {
  position: absolute;
  width: 20rem;
  height: 20rem;
  transform: translate(-50%, -50%);
  background: radial-gradient(
    circle closest-side at center,
    white,
    transparent
  );
  opacity: 0;
  transition: opacity 300ms ease;
}

.notiglow {
  z-index: 3;
}

.notiborderglow {
  z-index: 1;
}

.note {
  color: var(--color);
  position: fixed;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 0.9rem;
  width: 75%;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/components/frp/CardTitle.vue